import { createContext, useContext, useState, type ReactNode } from "react";

export type CompanyContextValue = {
  companyId: string | null;
  setCompanyId: (companyId: string | null) => void;
};

export interface CompanyContextProps {
  children: ReactNode;
}

const CompanyContext = createContext<CompanyContextValue>({
  companyId: null,
  setCompanyId: () => Promise.reject("Company context not initialised"),
});

export function CompanyContextProvider({ children }: CompanyContextProps) {
  const [companyId, setCompanyId] = useState<string | null>(null);
  return <CompanyContext.Provider value={{ companyId, setCompanyId }}>{children}</CompanyContext.Provider>;
}

export const useCompanyContext = (): CompanyContextValue => useContext(CompanyContext);
